import type { ReactNode } from 'react';

import type { Alignment, BackgroundColor } from '../../constants';
import type { BaseComponentProps } from '../../types';

export interface ImmersiveScrollBlockProps extends BaseComponentProps {
  eyebrow?: string;
  title: ReactNode;
  text?: string;
  tilesDirection?: Extract<Alignment, 'Start' | 'End'>;
  textAlignmentMobile?: Extract<Alignment, 'Start' | 'Center' | 'End'>;
  backgroundColor?: BackgroundColor;
  anchor?: string;
}
